import actions from "./snackbar.action";
import getters from "./snackbar.getters";
import mutations from "./snackbar.mutations";
import state from "./snackbar.state";

export default {
  actions,
  getters,
  mutations,
  state,
  namespaced: true,
};
